import { computed, ref } from "@vue/composition-api";
import axios from "@/libs/axios";
import { useToast } from "vue-toastification/composition";
// @ts-ignore
import ToastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
// @ts-ignore
import i18n from "@/libs/i18n";
import useActiveChat from "@/composables/useActiveChat";
import { ChatLogEntryTypeType } from "@/types/chatLogEntryType.type";
// @ts-ignore

export default function useActiveChatInternalComments() {
    const toast = useToast();
    const state = ref([]);
    const loading = ref(false);
    const { addActiveChatEntry } = useActiveChat();

    // @ts-ignore
    const createInternalComment = async ({ userId, identityId, comment }) => {
        loading.value = true;

        await axios
            .post(`/identities/${identityId}/internal-comments`, {
                userId,
                identityId,
                comment,
            })
            // @ts-ignore
            .then((response) => {
                // @ts-ignore
                state.value.push(response.data);
                addActiveChatEntry({
                    time: response.data.createdAt,
                    comment: response.data.comment,
                    userId: response.data.userId,
                    id: response.data.id,
                    identityId: response.data.identityId,
                    type: ChatLogEntryTypeType.INTERNAL_COMMENT,
                });

                toast({
                    component: ToastificationContent,
                    props: {
                        title: i18n.t("entities.internal-comments.Internal comment"),
                        text: i18n.t("toast.create.success", {
                            entity: i18n.t("entities.internal-comments.Internal comment"),
                        }),
                        icon: "check",
                        variant: "success",
                    },
                });
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: i18n.t("entities.internal-comments.Internal comment"),
                        text: i18n.t("toast.create.error", {
                            entity: i18n.t("entities.internal-comments.Internal comment"),
                        }),
                        icon: "times",
                        variant: "danger",
                    },
                });
            });

        loading.value = false;
    };

    // @ts-ignore
    const updateInternalComment = async ({ internalCommentId, identityId, comment }) => {
        console.debug("Update internal comment");

        loading.value = true;

        await axios
            .patch(`/identities/${identityId}/internal-comments/${internalCommentId}`, {
                comment: comment,
                editedAt: new Date(),
            })
            .then(() => {
                const internalCommentIndex = state.value.findIndex(
                    // @ts-ignore
                    (internalComment) => internalComment.id === internalCommentId
                );

                // @ts-ignore
                state.value.splice(internalCommentIndex, 1, {
                    // @ts-ignore
                    id: state.value[internalCommentIndex].id,
                    // @ts-ignore
                    comment: comment,
                    // @ts-ignore
                    createdAt: state.value[internalCommentIndex].createdAt,
                    // @ts-ignore
                    editedAt: new Date().toISOString(),
                    // @ts-ignore
                    userId: state.value[internalCommentIndex].userId,
                });

                toast({
                    component: ToastificationContent,
                    props: {
                        title: i18n.t("entities.internal-comments.Internal comment"),
                        text: i18n.t("toast.update.success", {
                            entity: i18n.t("entities.internal-comments.Internal comment"),
                        }),
                        icon: "check",
                        variant: "success",
                    },
                });
            })
            .catch(() =>
                toast({
                    component: ToastificationContent,
                    props: {
                        title: i18n.t("entities.internal-comments.Internal comment"),
                        text: i18n.t("toast.update.error", {
                            entity: i18n.t("entities.internal-comments.Internal comment"),
                        }),
                        icon: "times",
                        variant: "danger",
                    },
                })
            );

        loading.value = false;
    };

    // @ts-ignore
    const deleteInternalComment = async ({ internalCommentId, identityId }) => {
        loading.value = true;

        await axios
            .delete(`/identities/${identityId}/internal-comments/${internalCommentId}`)
            .then(() => {
                const internalCommentIndex = state.value.findIndex(
                    // @ts-ignore
                    (internalComment) => internalComment.id === internalCommentId
                );

                state.value.splice(internalCommentIndex, 1);

                toast({
                    component: ToastificationContent,
                    props: {
                        title: i18n.t("entities.internal-comments.Internal comment"),
                        text: i18n.t("toast.delete.success", {
                            entity: i18n.t("entities.internal-comments.Internal comment"),
                        }),
                        icon: "check",
                        variant: "success",
                    },
                });
            })
            .catch(() =>
                toast({
                    component: ToastificationContent,
                    props: {
                        title: i18n.t("entities.internal-comments.Internal comment"),
                        text: i18n.t("toast.delete.error", {
                            entity: i18n.t("entities.internal-comments.Internal comment"),
                        }),
                        icon: "times",
                        variant: "danger",
                    },
                })
            );

        loading.value = false;
    };

    // @ts-ignore
    const fetchInternalComments = (identityId: number, queryParams) => {
        return (
            axios
                .get(`/identities/${identityId}/internal-comments`, { params: queryParams })
                // @ts-ignore
                .then((response) => response.data)
                .catch(() =>
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: i18n.t("entities.internal-comments.Internal comment"),
                            text: i18n.t("toast.read.error", {
                                entity: i18n.t("entities.internal-comments.Internal comment"),
                            }),
                            icon: "times",
                            variant: "danger",
                        },
                    })
                )
        );
    };

    const loadInternalComments = async (identityId: number, queryParams: Record<string, unknown>): Promise<void> => {
        loading.value = true;
        state.value = await fetchInternalComments(identityId, queryParams);
        loading.value = false;
    };

    const getInternalComments = computed(() => state.value);
    const isLoading = computed(() => loading.value);

    return {
        getInternalComments,
        isLoading,

        // Methods
        loadInternalComments,
        createInternalComment,
        updateInternalComment,
        deleteInternalComment,
    };
}
